/**
 * 사이드바 네비게이션 섹션 컴포넌트 - Vertical Tabs 버전
 */ import React from 'react';
import { Tabs, Tab, cn, Chip } from '@heroui/react';
import { motion } from 'framer-motion';
import { MAIN_LAYOUT_TEST_IDS } from '@edusense/shared-constants';
export const NavigationSectionTabs = ({ navigationItems, activeMenu, onMenuClick, isTabletView, isMobileSidebar, isIconOnlyMode })=>{
    // 네비게이션 아이템 ID를 testid로 매핑하는 함수
    const getNavTestId = (itemId)=>{
        switch(itemId){
            case 'home':
                return MAIN_LAYOUT_TEST_IDS.NAV_FEED;
            case 'courses':
                return MAIN_LAYOUT_TEST_IDS.NAV_LEARN;
            case 'about':
                return MAIN_LAYOUT_TEST_IDS.NAV_DISCOVER;
            case 'profile':
                return MAIN_LAYOUT_TEST_IDS.NAV_PROFILE;
            case 'settings':
                return MAIN_LAYOUT_TEST_IDS.NAV_SETTINGS;
            default:
                return `nav-${itemId}`;
        }
    };
    const iconVariants = {
        inactive: {
            scale: 1,
            rotate: 0
        },
        active: {
            scale: 1.15,
            rotate: [
                0,
                -10,
                10,
                0
            ],
            transition: {
                rotate: {
                    duration: 0.4,
                    times: [
                        0,
                        0.25,
                        0.75,
                        1
                    ]
                },
                scale: {
                    duration: 0.2,
                    type: "spring",
                    stiffness: 300
                }
            }
        },
        hover: {
            scale: 1.1,
            transition: {
                duration: 0.2
            }
        }
    };
    const isCompact = typeof isIconOnlyMode === 'boolean' ? isIconOnlyMode : isTabletView;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn("w-full navigation-tabs-container overflow-visible", isMobileSidebar ? "px-2" : isCompact ? "px-1" : "px-4 pr-2")
    }, /*#__PURE__*/ React.createElement(Tabs, {
        "aria-label": "Navigation",
        selectedKey: activeMenu,
        onSelectionChange: (key)=>onMenuClick?.(key),
        variant: "light",
        color: "primary",
        orientation: "vertical",
        fullWidth: true,
        className: "navigation-tabs",
        classNames: {
            base: "w-full overflow-visible",
            tabList: cn("gap-2 p-0 w-full bg-transparent", "flex-col items-stretch overflow-visible"),
            cursor: "hidden",
            tab: cn("w-full px-3 h-12 relative z-10", "data-[selected=true]:bg-transparent", "data-[selected=true]:text-primary", "data-[selected=true]:font-semibold", "data-[hover-unselected=true]:bg-transparent", "data-[hover-unselected=true]:text-gray-700", "transition-all duration-300 ease-in-out"),
            tabContent: "group-data-[selected=true]:text-primary"
        }
    }, navigationItems.map((item)=>/*#__PURE__*/ React.createElement(Tab, {
            key: item.id,
            "data-testid": getNavTestId(item.id),
            title: /*#__PURE__*/ React.createElement(motion.div, {
                className: cn("flex items-center gap-3 w-full", isMobileSidebar ? "justify-start" : isCompact ? "justify-center" : "justify-end"),
                initial: "inactive",
                animate: activeMenu === item.id ? "active" : "inactive",
                whileHover: "hover"
            }, /*#__PURE__*/ React.createElement(motion.div, {
                "data-testid": "nav-icon-container",
                variants: iconVariants,
                className: cn("flex items-center justify-center", // Tailwind classes are being overridden, so we use inline styles.
                // isTabletView ? "w-10 h-10" : "w-6 h-6", 
                activeMenu === item.id ? "text-blue-500" : "text-gray-600"),
                style: {
                    width: isCompact ? '40px' : '24px',
                    height: isCompact ? '40px' : '24px',
                    minWidth: isCompact ? '40px' : '24px'
                }
            }, /*#__PURE__*/ React.isValidElement(item.icon) ? /*#__PURE__*/ React.cloneElement(item.icon, {
                ...item.icon.props,
                size: undefined,
                style: {
                    // Set a size smaller than the container
                    width: isCompact ? '24px' : '16px',
                    height: isCompact ? '24px' : '16px'
                }
            }) : item.icon), !isCompact && /*#__PURE__*/ React.createElement(motion.span, {
                className: "font-medium",
                initial: {
                    opacity: 0.8
                },
                animate: {
                    opacity: activeMenu === item.id ? 1 : 0.8
                }
            }, item.label), item.badge && /*#__PURE__*/ React.createElement(Chip, {
                size: "sm",
                variant: "flat",
                color: activeMenu === item.id ? "secondary" : "primary",
                className: "ml-auto"
            }, item.badge))
        }))));
};
export default NavigationSectionTabs;
